import { sendFeedback } from './reducers';
export default sendFeedback;
